export var TradePath;
(function (TradePath) {
    TradePath["ethToErc20"] = "ethToErc20";
    TradePath["erc20ToEth"] = "erc20ToEth";
    TradePath["erc20ToErc20"] = "erc20ToErc20";
})(TradePath || (TradePath = {}));
